"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_oop_1 = require("vue-oop");
class BaseModel extends vue_oop_1.Model {
    constructor(props) {
        super(props);
        if (!this.exists()) {
            this.generateUuid();
        }
    }
}
exports.default = BaseModel;
//# sourceMappingURL=BaseModel.js.map